import React, { useState } from "react";
import { JSONTree } from "react-json-tree";
import DynamicInput from "./DynamicInput";
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import APIResultMessage from "./APIResultMessage";
import { useTranslation } from "react-i18next";

const getCssVariable = (variableName) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
};

const theme = {
    scheme: "monokai",
    base00: "#F5F5F5", // Background
    base03: getCssVariable("--bs-slate-gray"), // Number of keys
    base0B: getCssVariable("--bs-crayola"), // Values
    base0D: getCssVariable("--bs-purple-pizzazz"), // keys
};

const jsonViewerStyle = {
    fontSize: "14px",
    fontFamily: "'Roboto', sans-serif",
    lineHeight: "1.5",
    padding: "10px",
    borderRadius: "8px",
    background: "#f5f5f5",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
};

const JsonViewer = ({ data, onChange }) => {
    const { t } = useTranslation();
    const [editMode, setEditMode] = useState(false);
    const [accessRuleError, setAccessRuleError] = useState(null);
    const [accessRuleValidated, setAccessRuleValidated] = useState(null);

    const validateAndSaveJson = (e) => {
        const value = e.target.value
        try{
            let json = null
            if(value) json = JSON.parse(value)
            onChange({target: {value: json}})
            setAccessRuleValidated({message: t('alert.validated')})
        } 
        catch(error) {
            onChange(e)
            console.log(error)
            setAccessRuleValidated(null)
            setAccessRuleError({message: t('error.invalidJson')})
        }
    }

    return (
        <div style={jsonViewerStyle}>
            {editMode ? 
                <>
                    <div className="w-100">
                        <APIResultMessage
                            success={accessRuleValidated}
                            error={accessRuleError}
                        />
                    </div>
                    <DynamicInput value={data} type={'json'} onChange={validateAndSaveJson}/>
                </>
            :
                <JSONTree 
                    data={data} 
                    theme={theme} 
                    invertTheme={false} 
                    hideRoot={true} 
                    shouldExpandNodeInitially={() => true} // Expand all
                />
            }
            {onChange && 
                <IconButtonWithTooltip translationId={editMode ? "button.done" : "button.edit"} icon={editMode ? faEye : faEdit} onClick={()=>(setEditMode(!editMode))} type="Button"/>
            }
        </div>
    );
};

export default JsonViewer;